<script setup lang="ts">
  import MainLayout from 'views/layouts/MainLayout.vue'
  import BannerAssineHorizontal from 'components/HomePage/BannerAssineHorizontal.vue'
  import HistoryCredits from 'components/MyCredits/HistoryCredits.vue'
</script>
<template>
  <MainLayout>
    <div class="slot-body" v-if="isLoggedIn">
      <div class="block--gray">
        <div class="container">
          <div class="row pt-4 d-flex align-items-center">
            <div class="col-lg-5">
              <h1 class="title">{{ translate.title }}</h1>
            </div>
            <div class="col-lg-7">
              <span class="subtitle">
                {{ translate.hello }} {{ user.nickname ?? user.name }}, {{ translate.sweetDo }} :
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 col-md-6 px-4 mt-5">
              <div class="row justify-content-start aling-items-center">
                <span
                  class="links col-lg-4 cursor-pointer"
                  @click="redirect('VideosDownloadsPage')"
                  >{{ translate.myVideos }}</span
                >
                <span class="links col-lg-4 cursor-pointer" @click="redirectCredits('AssineOptionsPage')">{{
                  translate.addCredits
                }}</span>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 px-4 mt-5">
              <div class="row justify-content-center aling-items-center">
                <span class="titleHistoryc col-lg-4 col-md-4 text-center">{{
                  translate.myHistory
                }}</span>
                <div class="col-lg-10 col-md-10 justify-content-center aling-items-center">
                  <hr />
                </div>
                <div
                  class="col-lg-9 col-md-9 d-flex flex-row justify-content-center aling-items-center"
                >
                  <div class="col-5 d-flex flex-column justify-content-center align-items-center">
                    <span class="number-download">{{ countDownloads }}</span>
                    <span class="title-download">{{ translate.totalDownloads }}</span>
                  </div>
                  <div class="col-5 d-flex flex-column justify-content-center align-items-center">
                    <span class="number-download">{{ countCredits }}</span>
                    <span class="title-download">{{ translate.totalCredits }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <HistoryCredits />
        </div>
      </div>
      <div class="container">
        <div class="row mt-3"></div>
        <div class="row mt-3 pb-5 d-flex align-items-center justify-content-center">
          <BannerAssineHorizontal :path="bannerAssineHorizontal" />
        </div>
      </div>
    </div>
  </MainLayout>
</template>
<script lang="ts">
  import { defineComponent } from 'vue'
  import { mapState } from 'pinia'
  import { userStore } from 'stores/user'
  import { localeStore } from 'stores/locale'
  import translaters from 'tradutors/mycredits'
  import IconeBds from 'assets/img/icone_BDS.png'
  import api from '../../api'
  import router from '../../router'
  import { isMobile } from "../shared/utils/mobile";

  export default defineComponent({
    name: 'MyCreditsPage',
    components: {
      BannerAssineHorizontal
    },
    head() {
      return {
        templateParams: {
          subTitle: null,
          subPage: 'Minha Conta',
          page_url: window.location.origin + this.$route.fullPath,
          page_description:
            this.locale == 'pt-br'
              ? `Descubra o que de melhor o Bella da Semana tem a oferecer...`
              : `Discover the best that Bella Club has to offer ...`,
          page_image: '/favicon.ico',
          page_keywords:
            'bella, bella da semana, bela da semana, bella semana, bela semana, belladasemana, bella site, bella da semana site',
          page_locale: this.locale,
          page_url_pt: 'https://belladasemana.com.br/pt-br/me/credits',
          page_url_en: 'https://belladasemana.com.br/en/me/credits',
          page_canonical: 'https://belladasemana.com.br' + this.$route.fullPath
        }
      }
    },
    computed: {
      ...mapState(localeStore, ['locale']),
      ...mapState(userStore, ['user', 'isLoggedIn']),
      translate: function () {
        if (this.locale === 'pt-br') {
          return translaters.portugues
        } else {
          return translaters.ingles
        }
      }
    },
    watch: {
      locale: function () {
        this.getBannerAssineHorizontal(true)
      }
    },
    created() {
      const lang = ['pt-br', 'en']
      if (lang.indexOf(this.$route.params.locale) === -1) {
        window.location.replace('/')
      }
      if (!this.isLoggedIn || !this.user) {
        router.push({ name: 'LoginPage' })
      }
      this.getBannerAssineHorizontal()
    },
    mounted() {
      this.getmyCreditsCount()
      this.getmyDownloadsCount()
    },
    data() {
      return {
        imgPath: IconeBds,
        hidden: true,
        password: '',
        email: '',
        bannerAssineHorizontal: '',
        countCredits: 0,
        countDownloads: 0,
        isMobile: isMobile(),        
      }
    },
    methods: {
      async getBannerAssineHorizontal(changeLanguage = false) {
        if (!sessionStorage.getItem("bannerAssineHorizontal") || changeLanguage)
          api.get(`v1/home/getBannerSuper?mobile=${isMobile()}&language=${this.locale}`).then(({ data }) => {
            this.bannerAssineHorizontal = data.bannerAssineHorizontal;
            sessionStorage.setItem(
              "bannerAssineHorizontal",
              JSON.stringify(this.bannerAssineHorizontal)
            );
          });
        else
          this.bannerAssineHorizontal = JSON.parse(
            sessionStorage.getItem("bannerAssineHorizontal")
          );
      },
      async getmyCreditsCount() {
        api.get(`v1/mycredits/getCredits`).then(({ data }) => {
          this.countCredits = data
        })
      },
      async getmyDownloadsCount() {
        api.get(`v1/mycredits/getDownloadsCount`).then(({ data }) => {
          this.countDownloads = data
        })
      },
      redirect(name) {
        router.push({
          name,
          params: {
            locale: this.locale
          },
          query: {
            acionador: this.$route.name
          }
        })
      },
      redirectCredits(name) {
        router.push({
          name,
          params: {
            locale: this.locale
          },
          query: {
            acionador: this.$route.name,
            redirectCredits: true
          }
        })
      }
    },
  })
</script>
<style scoped>
  .title-download {
    font-size: 14px;
    font-weight: 400;
    font-family: 'Roboto-Medium';
    line-height: 18.52px;
  }
  .number-download {
    font-size: 24px;
    font-weight: 500;
    font-family: 'Roboto-Medium';
    line-height: 28.13px;
  }

  hr {
    width: 238px;
    border: 1px solid #5b5858;
    margin: 0 auto;
    margin-top: 20px !important;
  }
  .links {
    font-size: 16px;
    font-weight: 500;
    font-family: 'Roboto-Medium';
    line-height: 28.13px;
    text-align: left;
  }

  .titleHistoryc {
    font-size: 16px;
    font-weight: 500;
    font-family: 'Roboto-Medium';
    line-height: 28.13px;
    text-align: left;
    cursor: default;
  }

  .links:hover {
    text-decoration: underline;
  }

  .slot-body {
    margin-top: 65px !important;    
    background-color: #fff !important;
  }

  .title {
    font-family: 'Bebas-Neue-Light';
    font-size: 64px;
    line-height: 77px;
    color: black;
  }

  .subtitle {
    font-family: 'Roboto-Medium';
    font-size: 24px;
    line-height: 28px;
    color: #999;
  }

  .img-default {
    width: 100%;
  }

  .d-w-btn button {
    color: #fff;
    padding: 5px;
  }

  .d-w-btn {
    background: #000;
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
  }

  .form-group input {
    padding: 15px 20px;
    border-radius: 30px;
    margin-bottom: 15px;
    background-color: #f8f8f8;
    font-size: small;
  }

  .input-group-text {
    padding: 0;
    padding-left: 5px;
    font-size: 2rem;
    background-color: #f8f8f8;
    border: 1px solid #ced4da;
    border-radius: 30px;
    border-left-style: hidden;
    height: 51px;
  }

  #inputPassword2 {
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
  }

  .icon-eye:before {
    color: #ced4da;
    margin-right: 0.5em;
    cursor: pointer;
  }

  hr {
    margin-top: 30px;
    border-bottom: solid 2px #ddd;
    margin-bottom: 30px;
  }

  .label-information {
    font-size: 16px;
  }

  .bulleted-list img {
    width: 20px;
    margin-right: 0.75em;
    object-fit: cover;
  }

  .img-banner-rodape {
    width: 1020px;
    height: 127px;
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .img-banner-rodape {
      width: 100%;
    }

    .title {
      font-family: 'Bebas-Neue-Light';
      font-size: 48px;
      line-height: 58px;
      color: black;
    }

    .subtitle {
      font-family: 'Roboto-Medium';
      font-size: 16px;
      line-height: 19px;
      color: #999;
    }

    .d-w-btn {
      left: 50%;
      transform: translate(-50%, 0%);
    }

  }
</style>
